import React from 'react'
import {
  Box,
  Flex,
  Text,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Heading,
  Button,
  Spinner,
} from '@chakra-ui/react'
import ReactPaginate from 'react-paginate'
import xhr from 'xhr'
import BasicModal from 'components/modal/Modal'
import { Link } from 'react-router-dom'
import SmartFilterBar from 'components/SmartFilterBar'

export default function ViewDataTeacher() {
  const [teachers, setTeachers] = React.useState([])
  const [student, setStudent] = React.useState([])
  const [isLoading, setIsLoading] = React.useState(true)
  const [isOpen, setIsOpen] = React.useState(false)
  const [fetching, setFetching] = React.useState(true)
  const [currentPage, setCurrentPage] = React.useState(1)
  const [teachersCount, setTeachersCount] = React.useState(0)
  const [filters, setFilters] = React.useState({ program_type: '', program: '', group: '', status: '', semester: '' })

  const getteachers = React.useCallback(async (page, programTypeFilter, programFilter) => {
    setIsLoading(true)
    try {
      const params = new URLSearchParams()
      params.set('pagination[page]', String(page))
      params.set('pagination[pageSize]', '10')
      if (programTypeFilter) params.set('program_type', programTypeFilter)
      if (programFilter) params.set('program', String(programFilter))
      const res = await xhr(`/teachers/pending-summary?${params.toString()}`)
      const payload = res?.data ?? res ?? {}
      const teacherList = payload.data ?? []
      const meta = payload.meta ?? {}
      const pagination = meta.pagination ?? {}

      setTeachersCount(pagination.pageCount ?? 0)
      setTeachers(Array.isArray(teacherList) ? teacherList : [])
    } catch (error) {
      console.error(error)
    } finally {
      setIsLoading(false)
    }
  }, [])

  React.useEffect(() => {
    getteachers(currentPage, filters.program_type || undefined, filters.program || undefined)
  }, [currentPage, filters.program_type, filters.program, getteachers])

  return (
    <Box p={4} maxW="100%">
      <SmartFilterBar
        title="Filtro"
        description="Filtrar pendientes de los profesores (opcional)"
        value={filters}
        onChange={setFilters}
        visibleFilters={['program_type', 'program']}
      />

      <Box
        mt={6}
        backgroundColor="white"
        borderRadius="10px"
        border="1px solid #e2e8f0"
        boxShadow="sm"
        overflow="hidden"
      >
        <Heading
          color="white"
          backgroundColor="#574feb"
          borderTopRadius="8px"
          paddingLeft="10px"
          fontSize="30px"
          fontWeight="bold"
          paddingTop="10px"
          paddingBottom="10px"
        >
          Datos pendientes de profesores
        </Heading>

        {isLoading ? (
          <Flex
            justifyContent="center"
            alignItems="center"
            gap={3}
            paddingY={10}
            paddingX={4}
            direction="column"
          >
            <Spinner size="lg" colorScheme="purple" thickness="3px" />
            <Text fontSize="sm" color="gray.600">
              Cargando datos pendientes de profesores…
            </Text>
          </Flex>
        ) : (
          <>
            <TableContainer px="13px">
              <Table margin="0px" size="xs">
                <Thead>
                  <Tr fontSize="13px">
                    <Th py="10px">ID</Th>
                    <Th py="10px">Correo</Th>
                    <Th py="10px">Profesor</Th>
                    <Th>N. Actividades</Th>
                    <Th>N. Preguntas</Th>
                    <Th>N. Chats</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {teachers.map((el, index) => {
                    return (
                      <Tr key={el.id ?? index}>
                        <Td textAlign="left" py="10px">
                          {el.id}
                        </Td>
                        <Td textAlign="left" py="10px">
                          {el.user.email}
                        </Td>
                        <Td textAlign="left" py="10px">
                          {el.user.first_name} {el.user.last_name}
                        </Td>
                        <Td fontSize="15px">{el.activities}</Td>
                        <Td fontSize="15px">{el.asks}</Td>
                        <Td fontSize="15px">{el.chats}</Td>
                      </Tr>
                    )
                  })}
                </Tbody>
              </Table>
            </TableContainer>
            <BasicModal isOpen={isOpen} setIsOpen={setIsOpen}>
              {fetching ? (
                <Spinner />
              ) : (
                <Box>
                  {student.user && (
                    <>
                      <Link
                        to={`/plataforma/administrador/ver-estudiante/${student.id}`}
                        target="_blank"
                      >
                        <Button
                          variant="outline"
                          colorScheme="purple"
                          size="sm"
                        >
                          Ir al perfil
                        </Button>
                      </Link>
                      <br />
                      Estudiante: {student.user?.first_name}{' '}
                      {student.user?.last_name}
                      <br />
                      Documento: {student.identity && student.identity}
                      <br />
                      Tipo Doc:{' '}
                      {student.identity_type && student.identity_type.name}
                      <br />
                      Dirección: {student.address && student.address}
                      <br />
                      Barrio: {student.neighborhood && student.neighborhood}
                      <br />
                      Ciudad: {student.city && student.city}
                      <br />
                      Departamento: {student.state && student.state}
                      <br />
                      Correo: {student.user.email && student.user.email}
                      <br />
                      Celular:{' '}
                      {student.user.cellphone && student.user.cellphone}
                    </>
                  )}
                </Box>
              )}
            </BasicModal>
          </>
        )}
      </Box>

      <Flex justifyContent="flex-end" marginTop={4}>
        <ReactPaginate
          breakLabel="..."
          nextLabel=">"
          onPageChange={(e) => setCurrentPage(e.selected + 1)}
          pageRangeDisplayed={2}
          pageCount={teachersCount}
          previousLabel="<"
          renderOnZeroPageCount={null}
          containerClassName="containerReactPaginate"
          pageClassName="liReactPaginate"
        />
      </Flex>

      <style jsx>{`
        .containerReactPaginate {
          display: flex;
          width: inherit;
          justify-content: space-evenly;
          list-style: none;
          width: 300px;
        }

        .selected {
          color: #574feb;
          font-weight: bold;
        }
      `}</style>
    </Box>
  )
}
